// extracted by mini-css-extract-plugin
module.exports = {"absolute":"video_absolute__2OHnf","mute_control":"video_mute_control__26HMj","scroll_arrow":"video_scroll_arrow__1cgUl"};